import QrCode from './qr-code.element.js';

export default QrCode;

QrCode.define('wje-qr-code', QrCode);
